import { LoginTypes } from 'shared-library';
import { createReducer, on } from '@ngrx/store';
import { StateStatuses } from '@app/store/enums/state-statuses.enum';
import { AuthState } from '@app/modules/auth/store/state/auth.states';
import * as AuthActions from '@app/modules/auth/store/actions/auth.actions';

export const authKey = 'auth';

export const initialState: AuthState = {
    error: "",
    data: {
        otp: "",
        code: "",
        name: "",
        email: "",
        mobile: "",
        company: "",
        id_token: "",
        password: "",
        cpassword: "",
        referral_id: "",
        recaptcha_token: "",
        password_strength: 0,
        activating_ots_qr: "",
        activation_code_ots_qr: "",
        auth_type: LoginTypes.EMAIL,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    responses: {
        login: null,
        signup: null
    },
    status: StateStatuses.PENDING,
};

export const authReducer = createReducer(
    initialState,

    on(AuthActions.loginSuccess, (state, { response }) => {
        return {
            ...state,
            responses: {
                ...state.responses,
                login: response.data
            },
            error: "",
            status: response.data.token_type === "session" ? StateStatuses.PROCESSING : StateStatuses.SUCCESS
        }
    }),
    on(AuthActions.login, (state, { data }) => {
        return {
            ...state,
            error: '',
            data: {
                ...state.data,
                auth_type: data.login_type
            },
            status: StateStatuses.PROCESSING
        }
    }),
    on(AuthActions.loginFailure, (state, { error }) => {
        if (state.data.auth_type === LoginTypes.LINK) {
            setTimeout(() => {
                window.location.href = `/404`
            }, 3000)
        }
        return {
            ...state,
            error: error.error,
            status: StateStatuses.FAILED,
            responses: {
                ...state.responses,
                login: {
                    ...state.responses.login,
                    token_type: null
                },
            }
        }
    }),
    on(AuthActions.setActivatingOTS, (state, { data }) => {
        return {
            ...state,
            data: {
                ...state.data,
                activating_ots_qr: data.short_id,
                activation_code_ots_qr: data.activation_code_ots_qr
            },
        }
    }),

    on(AuthActions.signupSuccess, (state, { response }) => {
        return {
            ...state,
            error: '',
            status: StateStatuses.PENDING,
            data: {
                ...state.data,
                password: initialState.data.password,
                cpassword: initialState.data.cpassword,
            },
            responses: {
                ...state.responses,
                signup: response
            }
        }
    }),

    on(AuthActions.signup, (state, { data }) => {
        return {
            ...state,
            error: '',
            data: {
                ...data,
                auth_type: data.auth_type,
            },
            responses: initialState.responses,
            status: StateStatuses.PROCESSING
        }
    }),

    on(AuthActions.signupFailure, (state, { error }) => {
        return {
            ...state,
            error: error.error,
            status: StateStatuses.FAILED,
            responses: {
                ...state.responses,
                signup: error,
            }
        }
    }),

    on(AuthActions.authTearDown, () => ({ ...initialState })),
    on(AuthActions.authSetStatus, (state, { status }) => ({ ...state, responses: initialState.responses, status, error: "" })),
);
